// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-layout {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1 0 100%;
}
.page-layout > *:last-child {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/wrappers/PageLayout/PageLayout.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;AACJ;AACI;EACI,gBAAA;AACR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
